import React from 'react'
import { useTheme } from '../../utils/useTheme'

export const AlertWarningIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref): React.ReactElement => {
    const theme = useTheme()
    return (
      <svg
        width="16"
        height="16"
        viewBox="5 3 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M10.2659 5.62455C11.8238 3.06107 15.5445 3.06108 17.1024 5.62455L21.8416 13.4226C23.4616 16.0883 21.5426 19.5 18.4233 19.5H8.94499C5.82568 19.5 3.90672 16.0883 5.52673 13.4226L10.2659 5.62455Z"
          fill={theme.tokens.background.semantic.warning.main.default}
        />
        <path
          d="M13.6819 12.1071L13.6819 8.70279"
          stroke={theme.tokens.foreground.main.staticBlack}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6818 15.4186L13.6818 15.3587"
          stroke={theme.tokens.foreground.main.staticBlack}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
)

export default AlertWarningIcon
